import _ from 'lodash';
import { DeploymentResult } from '../../Tabs/MockServices/Modals/DeploymentInfoModal';

export const getDeploymentBarKeyDescription = (key: string): string => {
  let desc = key;
  switch (key) {
    case 'starting':
      desc = 'Signal Deployment';
      break;
    case 'generatingData':
      desc = 'Generate Data';
      break;
    case 'indexingData':
      desc = 'Indexing Data';
      break;
    case 'containerReady':
      desc = 'Initializing Virtual Service Application';
      break;
    case 'startingContainer':
      desc = 'Starting Container';
      break;
    case 'finished':
      desc = 'Finished';
      break;
    case 'waitingForDomain':
      desc = 'Waiting for Domain';
      break;
  }
  return desc;
};

const colors = {
  starting: '#58b1f6',
  generatingData: '#3a84bd',
  startingContainer: '#a76feb',
  waitingForDomain: '#8d5acc',
  containerReady: '#5ceb76',
  indexingData: '#3aa54e',
  finished: '#3c3c3c',
};

export const getDeploymentBarColor = (key: string): string => {
  return colors[key];
};

export const reverseObjectProperties = (obj: any): any => {
  const mapped = {};
  //Reverse the results for the graph
  Object.keys(obj)
    .reverse()
    .forEach(key => {
      mapped[key] = obj[key];
    });
  return mapped;
};

export const calculateStageDurations = (events: StageEvent[]): DeploymentResult => {
  if (_.isNil(events)) {
    return {
      durations: {},
      totalDuration: 0,
    };
  }

  const durations: StageDurationsObject = {};
  let totalDuration = 0;
  for (let i = 0; i < events.length - 1; i++) {
    const currentEvent = events[i];
    const nextEvent = events[i + 1];

    const currentDateTime = new Date(currentEvent.dateTime).getTime();
    const nextDateTime = new Date(nextEvent.dateTime).getTime();

    const duration = (nextDateTime - currentDateTime) / 1000; // Convert to seconds

    // Use _.camelCase to generate the key
    const key = _.camelCase(currentEvent.stage);
    durations[key] = duration;
    totalDuration += duration;
  }

  //Reverse the object properties for the graph
  const reversedDurations = reverseObjectProperties(durations);

  return {
    durations: reversedDurations,
    totalDuration,
  };
};

type StageDurationsObject = {
  [key: string]: number; // Duration in seconds
};

export type StageEvent = {
  stage: string;
  dateTime: string;
};

export const convertStagesToArray = (staged: any) => {
  return _.map(staged, (elements, key) => {
    return {
      stage: key,
      dateTime: elements,
    };
  });
};
